<template>
  <div class="bulk-claims-table">
    <v-simple-table>
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.value">
            <Typography variant="subtitle-2">{{ column.label }}</Typography>
          </th>
          <th v-if="showErrorColumn">
            <Typography variant="subtitle-2">Error</Typography>
          </th>
          <th v-if="deletable" class="sticky-cell" />
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in mappedRows" :key="rowIndex">
          <td
            v-for="column in columns"
            :key="column.value"
            :class="{
              'error-border': hasError(row.id, column.value),
              'editable-cell': editable,
            }"
          >
            <v-text-field
              v-if="editable"
              v-model="row[column.value]"
              dense
              hide-details
              :error="hasError(row.id, column.value)"
              class="cell-input"
            />
            <Typography v-else variant="body-2">{{ row[column.value] || "" }}</Typography>
          </td>
          <td v-if="showErrorColumn">
            <Typography variant="body-2" class="error--text error-list">{{
              getRowErrors(row.id)
            }}</Typography>
          </td>
          <td v-if="deletable" class="sticky-cell">
            <Button color="#666" @click="$emit('delete-row', row.id)" text
              ><v-icon>mdi-delete</v-icon></Button
            >
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
export default {
  name: "BulkClaimsTable",
  components: {
    Typography,
    Button,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    mappedRows: {
      type: Array,
      default: () => [],
    },
    mappedRowsErrors: {
      type: Array,
      default: () => [],
    },
    deletable: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    showErrorColumn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hasError(rowId, columnValue) {
      return !!this.mappedRowsErrors.find(
        (errorRow) => errorRow.uuid === rowId && !!errorRow.errors[columnValue]
      );
    },
    getRowErrors(rowId) {
      const errorRow = this.mappedRowsErrors.find((e) => e.uuid === rowId);
      if (!errorRow) return "";
      return Object.values(errorRow.errors).flat().join("\n");
    },
  },
};
</script>

<style scoped>
.bulk-claims-table {
  width: 100%;
  text-align: left;
}

.bulk-claims-table ::v-deep .v-data-table {
  border: 1px solid #e0e0e0;
}

.bulk-claims-table ::v-deep .v-data-table table {
  border-collapse: separate;
  border-spacing: 0;
}

.bulk-claims-table ::v-deep thead tr {
  background-color: #eeeeee;
}

.bulk-claims-table ::v-deep tbody tr {
  background-color: white;
  &:hover {
    background-color: #eeeeee;
  }
}

.bulk-claims-table ::v-deep thead th {
  color: black !important;
}

.bulk-claims-table ::v-deep tbody tr {
  border-bottom: 1px solid #e0e0e0 !important;
}

.bulk-claims-table ::v-deep tbody tr td {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
  min-width: 200px !important;
}

.bulk-claims-table ::v-deep tbody tr td.editable-cell {
  padding: 0 !important;
}

.bulk-claims-table ::v-deep td.editable-cell .cell-input {
  height: 100%;
  margin: 0;
  padding: 0 16px;
}

.bulk-claims-table ::v-deep td.editable-cell .cell-input .v-input__control {
  height: 100%;
}

.bulk-claims-table ::v-deep td.editable-cell .cell-input .v-input__slot {
  height: 100%;
  align-items: center;
}

.bulk-claims-table ::v-deep .sticky-cell {
  position: sticky;
  right: 0;
  border-radius: 0 !important;
  background-color: inherit;
  min-width: auto !important;
}

.bulk-claims-table ::v-deep tbody tr td.error-border {
  border: 1px solid var(--v-error-base) !important;
}

.bulk-claims-table ::v-deep .cell-input .v-input__slot::before,
.bulk-claims-table ::v-deep .cell-input .v-input__slot::after {
  display: none !important;
}

.bulk-claims-table ::v-deep .cell-input.error--text input {
  color: var(--v-error-base) !important;
}

.error-list {
  white-space: pre-line;
}
</style>
